export default __webpack_public_path__ + "static/media/payroll-4.9aa7e58b.svg";